export default __webpack_public_path__ + "static/devops-eefdef3e92e7e80eb333eae1066b51bc.jpg";